import {
  Component,
  Input,
  Output,
  EventEmitter,
  computed,
  ChangeDetectionStrategy,
} from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import type { ToastItem } from '../toast.models';

@Component({
  selector: 'toast-item',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './toast-item.component.html',
  styleUrl: './toast-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastItemComponent {
  @Input({ required: true }) toast!: ToastItem;
  @Output() dismissed = new EventEmitter<string>();

  readonly hasBody = computed(() => !!this.toast?.title);
  readonly headerText = computed(() => this.toast?.title || this.toast?.message);

  readonly iconName = computed(() => {
    switch (this.toast?.type) {
      case 'success': return 'circle-check';
      case 'error':   return 'circle-x';
      case 'warning': return 'alert-triangle';
      case 'info':    return 'info';
      default:        return 'bell';
    }
  });

  onDismiss(): void {
    this.dismissed.emit(this.toast.id);
  }

  onActionClick(): void {
    this.toast.action?.onClick();
    this.dismissed.emit(this.toast.id);
  }
}
